import styled from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  ${media.greaterThan('large')`
    align-items: center;
  `}

  ${media.lessThan('small')`
    padding-top: 6rem;
  `}
`;
